import React from "react";
import orgLogo from "../Global Icons/orgLogo2.png";
import { Link } from "react-router-dom";
import { ReactComponent as BackIcon } from "../Assets/Categories/BackIcon.svg";

const ChatMirror = ({ emailAddress, phone }) => {
  return (
    <div className="mirror help-support-heading-wrapper flex-container flex-align-center flex-justify-between">
      <div className="help-backIcon">
        <Link to="/dashboard">
          <BackIcon style={{ cursor: "pointer", width: "60px", height: "60px", marginTop: "20px" }} />
        </Link>
        <div className="help-support-heading flex-container flex-justify-center flex-column">
          <h1>Help & Support</h1>
          <p>Help & Support</p>
        </div>
      </div>
      <div className="help-support-heading-card flex-container flex-column gap-25">
        <div className="item-01 flex-container flex-justify-between">
          <div className="item-01-left flex-container flex-column gap-5" style={{ alignItems: "start"}}>
            <p>Company Name</p>
            <p>dooritt</p>
          </div>
          <div className="item-01-right">
            <img
              src={orgLogo}
              alt="Dooritt Logo"
              style={{ width: "200px", height: "auto" }}
            />
          </div>
        </div>
        <div className="item-02 flex-container flex-justify-between">
          <div className="item-02-left flex-container flex-column gap-5">
            <p>Email Address</p>
            <p>Phone Number</p>
          </div>
          <div className="item-02-right flex-container flex-column gap-5">
            <p>{emailAddress || "No Data"}</p>
            <p>{phone || "No Data"}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatMirror;
